/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "ERateCentralPortalAPI",
            "endpoint": "https://6dkv4egjah.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:65afc458-274c-4527-b28f-0508c4ebf552",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_W6ME8YqCh",
    "aws_user_pools_web_client_id": "h8s6v7vguoh5phiojo3av12qn",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "eratecentralportal-frontend-staging",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1dmb64f3v8oxr.cloudfront.net",
    "aws_user_files_s3_bucket": "eratecentralportals3assets102827-staging",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
